import React, { ReactNode, PropsWithChildren } from "react";
import classNames from "classnames";

import "./TooltipContentWrapper.scss";

interface TooltipContentWrapperProps {
  title?: ReactNode;
  description?: ReactNode;
  wrapperClassName?: string;
}

export default function TooltipContentWrapper({
  title,
  description,
  wrapperClassName,
  children,
}: PropsWithChildren<TooltipContentWrapperProps>) {
  return (
    <div className={classNames("tooltip-content-wrapper", wrapperClassName)}>
      {title && <div className="tooltip-content-wrapper__title">{title}</div>}
      {description && (
        <div className="tooltip-content-wrapper__description">
          {description}
        </div>
      )}
      {children}
    </div>
  );
}
